import React, { useState, useContext, useRef, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Checkbox from '@material-ui/core/Checkbox';
import { AppContext, DispatchContext } from "../AppContext";
import PublicIcon from "@material-ui/icons/Public";
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ClearIcon from "@material-ui/icons/Clear";
import LibraryBooksSharpIcon from "@material-ui/icons/LibraryBooksSharp";
import { makeStyles } from "@material-ui/styles";
import TextField from '@material-ui/core/TextField';
import IconButton from "@material-ui/core/IconButton";
import WarningIcon from '@material-ui/icons/Warning';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import FilterListIcon from '@material-ui/icons/FilterList';
import SortIcon from '@material-ui/icons/Sort';
import * as actions from '../actions/actions';
import Popover from '@material-ui/core/Popover';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Service from "../services/service";
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import IconLabel from './IconLabel';
import DividerLabel from './DividerLabel';
import { config, formatPercent, buildHashedFilename, resolveNotificationMessage, createPercentageBar } from '../helpers/constants';
import { Typography } from "@material-ui/core";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import StatisticsCard from "./StatisticsCard";
import ColorBarLegend from "./ColorBarLegend";


const variants = ['body1', 'body1', 'body1', 'body1'];
var searchTypeTimeoutId = 0;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ffffff",
        zIndex: 3,
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        position: "relative",
        height: "100%",
    },
    topContentBox: {
        borderRadius: 4,
        display: "flex",
        alignItems: "end",
        padding: "10px 10px 0px 10px",
        flex: "0 0",
    },
    content: {
        flex: "1 0 0",
        minHeight: 0,
        overflowX: "hidden",
        overflowY: "auto",
        padding: 5
    },
    bottom: {
        flex: "0 0 65",
        minHeight: 65,
        borderTop: "1px solid #e3e3e3",
        paddingLeft: 16,
        paddingTop: 8
    },

    buttonPosition: {
        minWidth: "100%"
    },
    sourceCardPadding: {
        flex: "1 1 90%",
        justifyContent: "space-between",
        paddingLeft: "5px",
        paddingRight: "8px",
    },
    displayFlex: {
        display: "flex"
    },
    sourceCard: {
        display: "flex",
        flex: "1 1 auto",
        justifyContent: "space-between"
    },
    sourceCardContent: {
        display: "flex",
        flex: "1 1 auto",
        justifyContent: "space-between"
    },
    marginLeft: {
        marginLeft: "auto"
    },
    image: {
        height: '16px'
    },
    forwardIcon: {
        marginLeft: "auto",
        display: "flex"
    },
    popoverRoot: {
        maxWidth: '300px',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16
    },
    popUpRatingContainer: {
        marginLeft: "48px",
        width: "auto",
        padding: '10px 0px'
    },
    img: {
        height: "26px",
        marginLeft: "34px",
        width: "303px"
    },
    contentBorder: {
        border: "1px solid #e3e3e3",
        borderTop: "1px solid #e3e3e3",
        margin: "2px 0",
        borderRadius: 4,
        backgroundColor: '#F7F7F7',
    },
    contentBox: {
        padding: '5px 10px 5px 0',
        display: "flex",

        transition: 'background-color 0.2s',
        "align-items": "end",
        '&:hover': {
            cursor: "pointer",
            backgroundColor: "#eeeeee",
            transition: 'background-color 0.2s',
        },

        borderLeft: '13px solid transparent'
    },
    textMultiple: {
        '&:hover': {
            cursor: "pointer",
            color: "#0603ff",
        },
    },
    resetAction: {
        color: '#546cd6',
        cursor: 'pointer'
    },
    search_textArea: {
        margin: "0 10px",
        width: '100%',
        display: 'flex',
    },
    textField: {
        marginRight: theme.spacing(1),
        flex: "1"
    },
    customIcons: {
        height: "35px",
        marginTop: "10px",
        width: "35px"
    },
    rightAlign: {
        marginLeft: "auto",
        float: 'right'
    },
    contextItem: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        maxWidth: '100%'
    },
    sourcesDetail: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        maxWidth: '100%',
        display: "flex",
        width: "100%",
    },
    sourceCardPanel: {
        width: '100px'
    },
    active_Source: {
        backgroundColor: "#ff0000",
    },
    dispay_none: {
        display: "none",
    },
    dispay_block: {
        border: "1px solid #e3e3e3",
        backgroundColor: '#E6E6E6',
        margin: "2px 0",
        borderRadius: 4,
    },
    cursor_pointer: {
        cursor: 'pointer',
        display: "flex",
    },
    ratingPopupContent: {
        cursor: 'pointer',
        display: "flex",
        padding: "6px 15px",
        alignItems: 'center',
        '&:hover': {
            cursor: "pointer",
            backgroundColor: "#EEEEEE",
            transition: 'background-color 0.2s',
        },
    },
    // common colors class
    warning_icon: {
        color: "orange",
    },
    gridPopover: {
        minWidth: '30px',
        maxWidth: "30px",
        marginLeft: "auto",
        borderLeftStyle: "solid",
        borderLeftColor: "#e3e3e3",
        borderLeftWidth: "1px",
        alignSelf: "center"
    },
    align_icon_warning: {
        color: "orange",
        marginRight: 10,
        alignSelf: "centre",
    },
    alignSelf: {
        alignSelf: "centre"
    },
    excludedSource: {
        color: "#9fa7a4",
    },
    prohibited_icon: {
        color: "#9fa7a4",
    },
    sourceCardWidth: {
        alignSelf: "start",
        marginTop: "20px",
        marginLeft: "5px"
    },
    checkBox: {
        padding: "3px 3px",
    },

    align_icon_ban: {
        color: "#9fa7a4",
        marginRight: 10,
    },
    alignCentre: {
        color: "#9fa7a4",
        marginLeft: 10,
        marginRight: 10,
        alignItems: "centre"
    },
    suspiciousSource: {
        color: "orange",
    },
    onlineSource: {
        color: "#000066",
    },
    gridMargin: {
        marginLeft: 'auto',
    },
    check_icon: {
        color: "#017d01",
    },
    align_icon: {
        color: "#017d01",
        marginRight: 16,
        alignSelf: "centre",
    },
    acceptedSource: {
        color: "#017d01",
        verticalAlign: "middle",
    },
    public_icon: {
        color: "#000066",
    },
    text_end: {
        textAlign: "end",
    },
    urlOverFlow: {
        overflowX: "hidden",
        width: "80%",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: '#000000 !important'
    },
    filterRow: {
        cursor: "pointer",
    },
    topBlockContent: {
        paddingBottom: theme.spacing(1),
        //borderBottom: '1px solid #eeeeee',
        height: '90px'
    },
    filter_button: {
        height: "30px",
        marginTop: "10px",
        width: "30px"
    },
    typography: {
        padding: theme.spacing(2),
    },
    Idx: {
        fontWeight: '600'
    }
}));

let activePhase = 0;
export default function SourcePanelDetails(props) {
    const dispatch = useContext(DispatchContext);
    const rating = useRef(0);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const [activeCheckbox, setActiveCheckbox] = useState([]);
    const [oldCheckedIndex, setOldCheckedIndex] = useState({});
    const [filterPopup, setFilterPopup] = React.useState(null);
    const [sortPopup, setSortPopup] = React.useState(null);
    const [ratingPopup, setRatingPopup] = React.useState(null);
    const [sourceFilterText, setSourceFilterText] = React.useState("");

    const { scrollToContent, hoverToContent, hoverToOutContent, handleOpen, reloadReport } = props;


    // Sorting popup Data
    const resSortData = [
        {
            title: 'firstOccurenceDocument',
            value: '1',
            cols: 2,
            condition: 'Idx',
            type: 'asc'
        },
        {
            title: 'percentageDes',
            value: '2',
            cols: 2,
            condition: 'Percent',
            type: 'des'
        },
        {
            title: 'percentageAsc',
            value: '3',
            cols: 2,
            condition: 'Percent',
            type: 'asc'
        },
        {
            title: 'CopiedWordDes',
            value: '4',
            cols: 2,
            condition: 'MW',
            type: 'des'
        },
        {
            title: 'CopiedWordAsc',
            value: '5',
            cols: 2,
            condition: 'MW',
            type: 'asc'
        }
    ];



    // update filtered sources when filter settings or sources have changed
    useEffect(() => {
        setSourceFilterText(state.sourceFilter.searchTextValue);
        updateFilter();
    }, [state.sourceFilter, state.sources]);


    // hover effect in
    const activateHoverToSource = (source) => () => {
        if (source.Idx) {
            hoverToContent(source.Id);
            hoverToContent('list' + source.Idx);
        }
    };

    // hover effect out
    const activateHoverOutToSource = (source) => () => {
        if (source.Idx) {
            hoverToOutContent(source.Id);
            hoverToOutContent('list' + source.Idx);
        }
    };

    // source clicked, activate aource and scroll to it
    const activateScrollToSource = (source) => () => {
        if (source.Idx) {
            scrollToContent(source.Id + '_source' + '_phase_' + 1);
            activePhase = 1
        }
        var currentSource = source;
        const storeSource = state.activeSource;
        if (currentSource.Id != storeSource.Id) {
            dispatch(actions.setActiveSource(currentSource));
        }
    };

    // changed Filter text
    const onSearchFilterTextChange = (text) => {
        setSourceFilterText(text);
        clearTimeout(searchTypeTimeoutId);
        searchTypeTimeoutId = setTimeout(() => {
            dispatch(actions.setSourceFilter({ searchTextValue: text }));
        }, 500);
    };

    // sort changed
    const onHandleChangeSort = (sortId) => {
        dispatch(actions.setSourceFilter({ sortBy: sortId }));
    };

    // Source filter changed
    const onCheckedSources = (value, key) => {
        dispatch(actions.setSourceFilter({ [key]: value }))
    };

    // update state.searchedSources (called by effect when filter, sort or sources changed)
    const updateFilter = () => {
        let datatest = state.sources.filter((item) => {
            if (state.sourceFilter.searchTextValue) {
                if (!item.Title.toLowerCase().includes(state.sourceFilter.searchTextValue.toLowerCase())) {
                    return false;
                }
            }
            if (((state.sourceFilter.librarySource && item.Type == 'L')
                || (state.sourceFilter.librarySource && item.Type == 'F')
                || (state.sourceFilter.onlineSource && item.Type == 'W'))
                &&
                ((state.sourceFilter.acceptedSource && item.Used == 1 && item.Accepted == 1 && item.Excluded == 0)
                    || (state.sourceFilter.suspiciousSource && item.Used == 1 && item.Accepted == 0 && item.Excluded == 0)
                    || (state.sourceFilter.excludedSource && item.Excluded == 1)
                    || (state.sourceFilter.duplicatedSource && item.Used == 0))
            ) {
                return true;
            }
            return false;
        });

        const sourceFilterListCondition = resSortData.find(sort => sort.value == state.sourceFilter.sortBy);
        datatest = datatest.slice().sort((a, b) =>
            sourceFilterListCondition.type == 'asc' ?
                (a[sourceFilterListCondition.condition] || 9999) - (b[sourceFilterListCondition.condition] || 9999)
                :
                b[sourceFilterListCondition.condition] - a[sourceFilterListCondition.condition]
        );
        setActiveCheckbox([]);
        dispatch(actions.setSearchedSources(datatest));
    };

    const filterPopupClick = (event) => {
        setFilterPopup(event.currentTarget);
    };

    // select all / none / invert sources
    const onHandleSelectSourceList = (type) => {
        let sourceList = [];
        if (type == 'all') {
            state.searchedSources.map(source => {
                sourceList.push({
                    ...source,
                    checked: true
                })
            })
            setActiveCheckbox(sourceList)
        }
        else if (type == 'none') {
            setActiveCheckbox([])
        }
        else if (type == 'invert') {
            state.searchedSources.map(source => {
                if (!activeCheckbox.find(sourceList => sourceList.Id == source.Id)) {
                    sourceList.push({
                        ...source,
                        checked: true
                    })
                }
            })
            setActiveCheckbox(sourceList)
        }
    };

    // Selection of sources has changed
    const onSourceCheckboxChanged = (value, source, index, event) => {
        let dataUpdate = false;
        let indexUpdate = false;
        const enterShiftKey = event.nativeEvent.shiftKey;
        if (enterShiftKey && oldCheckedIndex.id) {
            let indexId1 = state.searchedSources.map(e => e.Id).indexOf(oldCheckedIndex.id);
            let index2 = index
            if (indexId1 > index) { index2 = indexId1 }
            else index = indexId1;
            let finalDataArray = [];
            state.searchedSources.slice(index, index2 + 1).map(item => {
                finalDataArray.push({
                    ...item,
                    checked: value
                })
            })
            if (value == true) {
                let dataAdded = finalDataArray.filter(source => activeCheckbox.find(sourceList => sourceList.Id != source.Id))
                setActiveCheckbox([
                    ...activeCheckbox,
                    ...dataAdded
                ])
            }
            else {
                let dataAdded = activeCheckbox.filter(source => !finalDataArray.find(sourceList => sourceList.Id == source.Id));
                setActiveCheckbox([
                    ...dataAdded
                ])
                if (dataAdded.length == 0) {
                    setOldCheckedIndex({})
                    indexUpdate = true;
                }
            }
            dataUpdate = true
        }
        if (!dataUpdate && activeCheckbox.find(sourceList => sourceList.Id == source.Id)) {
            if (activeCheckbox.length == 1) {
                setOldCheckedIndex({})
                indexUpdate = true;
            }
            setActiveCheckbox(activeCheckbox.filter(sourceList => sourceList.Id != source.Id))
        }
        else if (!dataUpdate) {
            setActiveCheckbox([
                ...activeCheckbox,
                {
                    ...source, checked: value
                }
            ]
            )
        }
        if (!indexUpdate) {
            setOldCheckedIndex({ id: source.Id, value })
        }
    };

    const filterPopupClose = () => {
        setFilterPopup(null);
    };

    const sortPopupClick = (event) => {
        setSortPopup(event.currentTarget);
    };

    const sortPopupClose = () => {
        setSortPopup(null);
    };

    const ratingPopupClose = () => {
        setRatingPopup(null);
    };

    const ratingPopupClick = (event, source) => {
        event.stopPropagation()
        rating.current = source;
        setRatingPopup(event.currentTarget);
    };

    const openSourceUrl = (source) => {
        window.open(source.Url, "_blank");
    };

    const changePhase = (source, type, event) => {
        event.stopPropagation()

        if (source.Idx) {
            if (activePhase == 0) {
                scrollToContent(source.Id + '_source' + '_phase_' + 1);
            }
            else {
                activePhase = type == 'next' ? activePhase + 1 : activePhase - 1;
                activePhase = Math.max(1, Math.min(activePhase, parseInt(source.MP)));
                scrollToContent(source.Id + '_source' + '_phase_' + activePhase);
            }
        }
    };

    // Reset source filter and Sorting 
    const onResetHandle = () => {
        setActiveCheckbox([]);
        dispatch(actions.setSourceFilter({
            onlineSource: true,
            librarySource: true,
            acceptedSource: true,
            suspiciousSource: true,
            excludedSource: false,
            duplicatedSource: false,
            sortBy: 1,
            searchTextValue: ""
        }));
    };

    // Perform Rating Action
    const handleChangedRatingButton = (updateSoruceDetail, type) => {
        ratingPopupClose();
        let data = [];
        if (type == 'single') {
            data.push(updateSoruceDetail)
        }
        else if (activeCheckbox.length > 0) {
            activeCheckbox.map(source => {
                data.push({
                    ...updateSoruceDetail,
                    sid: source.Id
                })
            })
        }

        Service.updateSources(data, state.activeReport.Id, state.ui.permaLinkId).then(res => {
            if (res.success) {
                dispatch(actions.openToast({ type: "success", message: s.notificationMessage.sourceUpdated, status: true }));
                reloadReport();
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
            }
        });
    };

    const onSourcesViewChanged = (event, newView) => {
        if (newView != null) {
            dispatch(actions.setUI({ sourcesView: newView }));
        }
    }

    const handleStatisticsTypeChange = (newTypeId) => {
        if (newTypeId != state.ui.statisticsType) {
            dispatch(actions.setUI({ statisticsType: newTypeId }));
            dispatch(actions.set_text_overlay([]));
        }
    }


    const numberOfRelevantSources = state.sources.filter(s => s.Used == 1 && s.Excluded == 0).length || 0;
    const numberOfMatchingSources = state.searchedSources.length || 0;
    const numberOfTotalSources = state.sources.length || 0;


    return (
        <div className={classes.root}>
            <div className={classes.topBlockContent}>
                <Grid container className={classes.topContentBox}>
                    <Grid>
                        {state.activeReport.TextOverlayExists &&
                            <ToggleButtonGroup
                                value={state.ui.sourcesView}
                                onChange={onSourcesViewChanged}
                                exclusive
                                size="small"
                            >
                                <ToggleButton value="sources" style={{ width: 175 }}>
                                    {s.reportReview.sourcesFilterCount.format(numberOfMatchingSources, numberOfRelevantSources, numberOfTotalSources)}
                                </ToggleButton>
                                <ToggleButton value="statistics" style={{ width: 175 }}>
                                    {s.kiDetector.aiAnalysis}
                                </ToggleButton>
                            </ToggleButtonGroup>
                        }{!state.activeReport.TextOverlayExists && <Grid >
                            <Typography variant="body2">{s.reportReview.sourcesFilterCountNoTextOverlay.format(numberOfMatchingSources, numberOfRelevantSources, numberOfTotalSources)}</Typography>
                        </Grid>}

                    </Grid>

                </Grid>
                {(state.ui.sourcesView == "sources") &&
                    <Grid container>
                        <div className={classes.search_textArea}>
                            <TextField
                                value={sourceFilterText}
                                name="search-text"
                                placeholder={s.search}
                                onChange={(evt) => onSearchFilterTextChange(evt.target.value)}
                                className={classes.textField}
                                margin="dense"
                            />
                            <div className={classes.rightAlign}>
                                <IconButton data-for="globalTT" data-tip={s.reportReview.filterSourcesTip} className={classes.customIcons} variant="contained" color="primary" onClick={filterPopupClick}><FilterListIcon /></IconButton>
                                <IconButton data-for="globalTT" data-tip={s.reportReview.sortSourcesTip} className={classes.customIcons} variant="contained" color="primary" onClick={sortPopupClick}><SortIcon /></IconButton>
                                <IconButton data-for="globalTT" data-tip={s.reportReview.resetFilterTip} className={classes.customIcons} variant="contained" color="primary" onClick={onResetHandle}><ClearIcon /></IconButton>
                            </div>
                            {/* filter selection panel */}
                            <Popover id={'filterPopover'} open={Boolean(filterPopup)} anchorEl={filterPopup} onClose={filterPopupClose}
                                classes={{
                                    paper: classes.popoverRoot,
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}>
                                <DividerLabel label={s.sourceOrigin} />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.onlineSource} onChange={(e) => onCheckedSources(e.target.checked, "onlineSource")} />}
                                    label={<IconLabel label={s.onlineSource} icon={<PublicIcon className={classes.onlineSource} />} />}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.librarySource} onChange={(e) => onCheckedSources(e.target.checked, "librarySource")} />}
                                    label={<IconLabel label={s.librarySource} icon={<LibraryBooksSharpIcon className={classes.onlineSource} />} />}
                                />
                                <DividerLabel label={s.sourceRating} />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.suspiciousSource} onChange={(e) => onCheckedSources(e.target.checked, "suspiciousSource")} />}
                                    label={<IconLabel label={s.suspiciousSource} icon={<WarningIcon className={classes.suspiciousSource} />} />}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.acceptedSource} onChange={(e) => onCheckedSources(e.target.checked, "acceptedSource")} />}
                                    label={<IconLabel label={s.acceptedSource} icon={<CheckCircleIcon className={classes.acceptedSource} />} />}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.excludedSource} onChange={(e) => onCheckedSources(e.target.checked, "excludedSource")} />}
                                    label={<IconLabel label={s.excludedSource} icon={<NotInterestedIcon className={classes.excludedSource} />} />}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.sourceFilter.duplicatedSource} onChange={(e) => onCheckedSources(e.target.checked, "duplicatedSource")} />}
                                    label={<IconLabel label={s.duplicatedSource} icon={<FilterNoneIcon className={classes.excludedSource} />} />}
                                />
                            </Popover>

                            {/* sort popover start */}
                            <Popover id={'sortPopover'} open={Boolean(sortPopup)} anchorEl={sortPopup} onClose={sortPopupClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}>
                                <div className={classes.typography}>
                                    <RadioGroup className={classes.gridList}>
                                        {resSortData.map((tile, index) => (
                                            <FormControlLabel key={index} checked={state.sourceFilter.sortBy == tile.value} onChange={(evt) => onHandleChangeSort(evt.target.value)} value={tile.value} control={<Radio />} label={state.strings[tile.title]} />
                                        ))}
                                    </RadioGroup>
                                </div>
                            </Popover>
                        </div>
                    </Grid>}
            </div>

            {/* Source List Details Start */}
            {(state.ui.sourcesView == "sources") &&
                <>
                    <div className={classes.content}>
                        {!state.loadingSource ? (<Grid container>
                            {variants.map((variant, index) => (
                                <Grid container key={index}>
                                    <Grid container className={classes.dispay_block}>
                                        <Grid container className={classes.contentBox}>
                                            <Grid item xs={1} className={classes.checkBox}>
                                                <Skeleton animation="wave" className={classes.skeleton} variant={'text'} />
                                            </Grid>
                                            <Grid item xs={9} >
                                                <Skeleton animation="wave" className={classes.skeleton} variant={'text'} />
                                                <Skeleton animation="wave" className={classes.skeleton} variant={'text'} />
                                            </Grid>
                                            <Grid item xs={1} className={classes.gridMargin}>
                                                <Skeleton animation="wave" variant={'text'} />
                                                <Skeleton animation="wave" className={classes.skeleton} variant={'text'} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>) :
                            <Grid container>
                                {
                                    !state.sources.length ?
                                        <IconLabel mt={24} centered label={s.noSources} /> :
                                        !state.searchedSources.length ?
                                            <IconLabel centered mt={24} label={s.noFilterSources} /> :
                                            <Grid container>
                                                {state.searchedSources.map((source, index) => {
                                                    const sourceTypeIcon = (source.Type == "W") ? <PublicIcon className={classes.public_icon} /> :
                                                        (source.Type == "F") ? <FingerprintIcon className={classes.public_icon} /> :
                                                            <LibraryBooksSharpIcon className={classes.public_icon} />;
                                                    const sourceTypeTooltip = (source.Type == "W") ? s.onlineSourceTip :
                                                        (source.Type == "F") ? s.fingerprintSourceTip : s.librarySourceTip;
                                                    const checkBoxValue = activeCheckbox.find(sourceList => sourceList && sourceList.Id == source.Id && sourceList.checked);
                                                    const borderColor = source.Idx ? state.ui.colors[source.Idx % 10] : "transparent";
                                                    return (
                                                        <Grid container id={source.Id} key={source.Id}  >
                                                            <div onClick={activateScrollToSource(source)}
                                                                onMouseEnter={activateHoverToSource(source)}
                                                                onMouseLeave={activateHoverOutToSource(source)}
                                                                className={`${'list' + source.Idx} ${classes.sourceCard} ${state.activeSource.Id == source.Id ? classes.dispay_block : classes.contentBorder}`}>

                                                                <div style={{ borderColor: borderColor }} className={`${classes.contentBox} ${classes.sourceCardContent}`}>
                                                                    <div className={classes.sourceCardWidth}>
                                                                        <Checkbox className={classes.checkBox}
                                                                            color="primary"
                                                                            disabled={state.activeReport.ReadOnly}
                                                                            checked={checkBoxValue ? true : false}
                                                                            onChange={(evt) => onSourceCheckboxChanged(evt.target.checked, source, index, evt)}
                                                                        />
                                                                    </div>
                                                                    <div className={`${classes.sourceCardPanel} ${classes.sourceCardPadding}`} >
                                                                        <div data-for="globalTT" data-tip={source.Title} className={classes.contextItem}>
                                                                            <span className={classes.Idx}>{!source.Idx ? 'n/a' : source.Idx}</span> - {source.Title}
                                                                        </div>

                                                                        <div className={classes.displayFlex}>
                                                                            <div className={classes.contextItem}>
                                                                                {s.reportReview.sourceStats.format(formatPercent(source.Percent), source.MW, source.MP)}
                                                                            </div>
                                                                            <div className={classes.forwardIcon}>
                                                                                <span className={classes.cursor_pointer} onClick={(event) => changePhase(source, 'previous', event)} ><SkipPreviousIcon /></span>
                                                                                <span className={classes.cursor_pointer} onClick={(event) => changePhase(source, 'next', event)} ><SkipNextIcon /></span>
                                                                            </div>
                                                                        </div>

                                                                        <img
                                                                            data-for="globalTT" data-tip={s.reportReview.openSideBySideTip}
                                                                            src={buildHashedFilename(config.backendUrl + "gfx/reportimg", state.activeReportId, "sourcebar245_{0}_{1}.png".format(state.activeReportId, source.Id))}
                                                                            alt="new"
                                                                            className={classes.image}
                                                                            onClick={() => handleOpen(true, source.Id)}
                                                                        />
                                                                    </div>

                                                                    <Grid item xs={2} className={classes.gridPopover} >
                                                                        <Button data-for="globalTT" data-tip={sourceTypeTooltip} classes={{
                                                                            root: classes.buttonPosition
                                                                        }} onClick={() => openSourceUrl(source)}>{sourceTypeIcon}</Button>
                                                                        {
                                                                            (source.Used == 1 && source.Accepted == 1 && source.Excluded == 0) ?
                                                                                <Button data-for="globalTT" data-tip={s.reportReview.ratedAcceptedTip} disabled={state.activeReport.ReadOnly} data-place="bottom" className={classes.cursor_pointer} classes={{
                                                                                    root: classes.buttonPosition
                                                                                }} onClick={(evt) => ratingPopupClick(evt, source)}>
                                                                                    <CheckCircleIcon className={classes.check_icon} />
                                                                                </Button>
                                                                                :
                                                                                (source.Used == 1 && source.Accepted == 0 && source.Excluded == 0) ?
                                                                                    <Button data-for="globalTT" data-tip={s.reportReview.ratedSuspiciousTip} disabled={state.activeReport.ReadOnly} data-place="bottom" className={classes.cursor_pointer} classes={{
                                                                                        root: classes.buttonPosition
                                                                                    }} onClick={(evt) => ratingPopupClick(evt, source)}>
                                                                                        <WarningIcon className={classes.warning_icon} />
                                                                                    </Button>
                                                                                    :
                                                                                    source.Excluded == 1 ?
                                                                                        <Button data-for="globalTT" data-tip={s.reportReview.ratedExcludedTip} disabled={state.activeReport.ReadOnly} className={classes.cursor_pointer} classes={{
                                                                                            root: classes.buttonPosition
                                                                                        }} onClick={(evt) => ratingPopupClick(evt, source)}>
                                                                                            <NotInterestedIcon className={classes.prohibited_icon} />
                                                                                        </Button> :
                                                                                        <Button data-for="globalTT" data-tip={s.reportReview.ratedDuplicatedTip} disabled={state.activeReport.ReadOnly} className={classes.cursor_pointer} classes={{
                                                                                            root: classes.buttonPosition
                                                                                        }} onClick={(evt) => ratingPopupClick(evt, source)}>
                                                                                            <FilterNoneIcon className={classes.prohibited_icon} />
                                                                                        </Button>
                                                                        }
                                                                    </Grid>

                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                }

                                {/* Rating PopUp */}
                                <Popover id={'ratingPopover'} open={Boolean(ratingPopup)} anchorEl={ratingPopup}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: "left",
                                    }}
                                    classes={{
                                        paper: classes.popUpRatingContainer
                                    }}
                                    onClose={ratingPopupClose} >
                                    {
                                        ((rating.current.Used == 1 && rating.current.Accepted == 0) || rating.current.Excluded || !rating.current.Used) &&
                                        <div className={classes.ratingPopupContent} onClick={() => handleChangedRatingButton({ acc: 1, sid: rating.current.Id }, 'single')}>
                                            <CheckCircleIcon style={{ marginRight: 8 }} className={classes.check_icon} />
                                            <Typography>{s.reportReview.markSourceAsIndicate}</Typography>
                                        </div>
                                    }
                                    {
                                        ((rating.current.Used == 1 && rating.current.Accepted == 1) || rating.current.Excluded || !rating.current.Used) &&
                                        <div className={classes.ratingPopupContent} onClick={() => handleChangedRatingButton(
                                            { acc: 0, sid: rating.current.Id }, 'single'
                                        )}>
                                            <WarningIcon style={{ marginRight: 8 }} className={classes.warning_icon} />
                                            <Typography>{s.reportReview.markSourceAsSuspicious}</Typography>
                                        </div>
                                    }
                                    {
                                        (!rating.current.Excluded) &&
                                        <div className={classes.ratingPopupContent} onClick={() => handleChangedRatingButton(
                                            { exc: 1, sid: rating.current.Id }, 'single'
                                        )}>
                                            <NotInterestedIcon style={{ marginRight: 8 }} className={classes.prohibited_icon} />
                                            <Typography>{s.reportReview.excludeSource}</Typography>
                                        </div>
                                    }
                                </Popover>
                                {/* Ratinf PopUp End */}
                            </Grid>
                        }
                    </div>
                    <div className={classes.bottom}>
                        <div>
                            <span className={classes.textMultiple} onClick={() => onHandleSelectSourceList('all')}>{s.common.all}</span>&nbsp;|&nbsp;
                            <span className={classes.textMultiple} onClick={() => onHandleSelectSourceList('none')}>{s.common.none}</span>&nbsp;|&nbsp;
                            <span className={classes.textMultiple} onClick={() => onHandleSelectSourceList('invert')}>{s.common.invert}</span>
                        </div>
                        {((activeCheckbox.length > 0) && (!state.activeReport.ReadOnly)) &&
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {s.reportReview.selectedSources.format(activeCheckbox.length)}
                                <IconButton style={{ marginLeft: 8 }} data-for="globalTT" data-place="top" data-tip={s.reportReview.markSourcesAsIndicate} size="small" onClick={() => handleChangedRatingButton({ acc: 1 })}>
                                    <CheckCircleIcon className={classes.check_icon} />
                                </IconButton>
                                <IconButton data-for="globalTT" data-tip={s.reportReview.markSourcesAsSuspicious} size="small" onClick={() => handleChangedRatingButton({ acc: 0 })}>
                                    <WarningIcon className={classes.warning_icon} />
                                </IconButton>
                                <IconButton data-for="globalTT" data-tip={s.reportReview.excludeSources} size="small" onClick={() => handleChangedRatingButton({ exc: 1 })}>
                                    <NotInterestedIcon className={classes.prohibited_icon} />
                                </IconButton>
                            </div>
                        }
                    </div>
                </>

            }
            {(state.ui.sourcesView == "statistics") &&
                <>
                    <div className={classes.content}>
                        {Object.keys(state.overlayStatistics).filter((key) => key != "phrases").sort((a, b) => state.ui.textOverlay[a].order - state.ui.textOverlay[b].order).map((typeId) => {
                            return (
                                <StatisticsCard handleChange={handleStatisticsTypeChange} typeId={typeId} helpUrl={config.backendUrl + s.kiDetector.helpUrl} title={s.kiDetector[state.ui.textOverlay[typeId].title]}></StatisticsCard>
                            );
                        })}
                    </div>
                    <div className={classes.bottom}>
                        <ColorBarLegend />
                    </div>
                </>
            }
            {/* Source List Details End */}

        </div>
    );
}
